import { useConfig } from '@gef-ui/env-config';
import useRouter from '@gef-ui/router-core/hooks/useRouter';
import React, { useEffect, useRef, useState } from 'react';
import { createClient } from '../Oauth2Client';
import { AuthContext } from '../context';
import { parseQuery } from '../utils';
const defaultUseHandleErrorLogout = ()=>{
    return undefined;
};
const ERROR_ROUTE = '/_error';
const AuthorizationProvider = ({ onClientCreated, children, waitForFirstToken, waitForFullAuthProcess, loader, useHandleErrorLogout = defaultUseHandleErrorLogout, ignoredRoutes = [], ...rest })=>{
    const router = useRouter();
    const removeQueryParams = router.useRemoveQueryParams();
    const pushFn = router.usePush();
    const { pathname } = router.useLocation();
    const isIgnoredRoute = [
        ERROR_ROUTE,
        ...ignoredRoutes
    ].includes(pathname);
    const config = useConfig();
    const isDevLogin = config.devUsername && config.devPassword;
    const didInitialise = useRef(false);
    const [hasFirstToken, setHasFirstToken] = useState(false);
    const [isAfterCode] = useState(isDevLogin || !!parseQuery(window.location.search)?.code);
    const [hasAuthCompleted, setHasAuthCompleted] = useState(false);
    const handleErrorLogout = useHandleErrorLogout();
    const [client] = useState(()=>{
        if (typeof window !== 'undefined') {
            return createClient({
                config,
                removeQueryParams,
                changeRoute: pushFn,
                ...rest,
                onNewToken: (token)=>{
                    rest.onNewToken?.(token);
                    if (waitForFirstToken) {
                        setHasFirstToken(true);
                    }
                },
                errorLogout: handleErrorLogout,
                afterAuthentication: ()=>{
                    rest.afterAuthentication?.();
                    if (waitForFullAuthProcess) {
                        setHasAuthCompleted(true);
                    }
                }
            });
        }
    });
    useEffect(()=>{
        if (didInitialise.current) {
            return;
        }
        onClientCreated?.(client);
    }, [
        client,
        onClientCreated
    ]);
    useEffect(()=>{
        if (didInitialise.current || isIgnoredRoute) {
            return;
        }
        didInitialise.current = true;
        (async ()=>{
            await client?.handleLogin();
        })();
    }, [
        client,
        isIgnoredRoute
    ]);
    let content = children;
    if (isIgnoredRoute) {
    // route ignored, keep children as content
    } else if (waitForFirstToken && !hasFirstToken) {
        content = loader;
    } else if (!waitForFirstToken && !isAfterCode) {
        content = loader;
    } else if (waitForFullAuthProcess && !hasAuthCompleted) {
        content = loader;
    }
    return /*#__PURE__*/ React.createElement(AuthContext.Provider, {
        value: client
    }, content);
};
export default AuthorizationProvider;
